import { useContext } from "react";

// icons
import { BiCheckCircle, BiXCircle, Close } from "../icons/AppIcons.jsx";


// import lang context
import { LangContext } from "../../context/LangContext.jsx";

// import notification context
import { NotificationContext } from "../../context/NotificationContext.jsx";






export const ToastNotification = ({ success = false, error = false, msg = "" }) => {

  // GET the lang context
  const { lang } = useContext(LangContext);

  const { handleClose } = useContext(NotificationContext);



  return (
    <>
      {
        success && (
          <div className="container-toast">
            <div className="bg-right-success"></div>
            <div className="icon-toast row-flex justify-center align-c">
              <BiCheckCircle />
            </div>
            <div className="body-toast flex-auto">
              <h5>{lang === "en" ? "Success" : "Exitoso"}</h5>
              <strong>{msg}</strong>
              <button type="button" className="btn-close btn-p-abso" onClick={handleClose}>
                <Close fillP="var(--first-color)" />
              </button>
            </div>
          </div>
        )
      }
      {
        error && (
          <div className="container-toast">
            <div className="bg-right-error"></div>
            <div className="icon-toast row-flex justify-center align-c">
              <BiXCircle />
            </div>
            <div className="body-toast flex-auto">
              <h5 style={{ color: 'var(--danger-color)' }}>Error</h5>
              <strong>{msg}</strong>
              <button type="button" className="btn-close btn-p-abso" onClick={handleClose}>
                <Close fillP="var(--first-color)" />
              </button>
            </div>
          </div>
        )
      }
    </>
  );
};